// eslint-disable-next-line no-undef
const DOMAIN = Shopify.shop || Shopify.Checkout?.apiHost || location.hostname

// eslint-disable-next-line no-undef
export const STOREFRONT_URL = `https://${Shopify.shop}/api/2024-01/graphql.json`

const DEV_HOSTNAME = 'king-living-outlet-dev.myshopify.com'
const PROD_HOSTNAME = 'king-living-outlet-prod.myshopify.com'

// Details for Storefront API.
const storefrontAccessToken = {
  [DEV_HOSTNAME]: '4d00491a1c91b3215ff4df4ce0344c86',
  [PROD_HOSTNAME]: 'f03d656f9ee90904c13e722e8396946f'
}

function getAccessToken () {
  // eslint-disable-next-line no-undef
  return storefrontAccessToken[Shopify.shop]
}

export const storefrontRequestConfig = {
  headers: {
    'Content-Type': 'application/graphql',
    'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
}

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}

// Middleware
function middlewareUrl () {
  // eslint-disable-next-line no-undef
  switch (DOMAIN) {
    case 'king-living-outlet-prod.myshopify.com':
      return 'kinglivingsap-outlet.testarc.com.au'
    default:
      return 'kinglivingsap-outletdev.testarc.com.au'
  }
}

export function getNewsletterAPI () {
  // Use theme setting if available, otherwise fall back to default middleware URL
  if (typeof window !== 'undefined' && window.theme?.api?.newsletter) {
    return window.theme.api.newsletter
  }
  return `https://${middlewareUrl()}/sap/newsletter/subscribe?shop=${DOMAIN}`
}
